import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { StatusIndicatorMode } from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-status-indicator-display',
  imports: [CommonModule, MatIconModule],
  templateUrl: './status-indicator-display.component.html',
  styleUrl: './status-indicator-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex' },
})
export class StatusIndicatorDisplayComponent {
  backgroundColour = input.required<string>();
  mode = input.required<StatusIndicatorMode>();
  colour = input<string>();
  character = input<string>();
  icon = input<string>();
  statusIndicatorMode = StatusIndicatorMode;
  white = '#FFFFFF';
}
